import { User } from '@auth0/auth0-react'

export function isAdmin(user: User | null | undefined): boolean {
  if (!user) return false
  
  // Check permissions in token claims
  const permissions = (user['https://midwestrailbirds.com/permissions'] as string[]) || []
  
  const isAdminUser = permissions.includes('admin')
  
  return isAdminUser
}

export function isPoolAdmin(user: User | null | undefined): boolean {
  if (!user) return false
  const permissions = (user['https://midwestrailbirds.com/permissions'] as string[]) || []
  return permissions.includes('pool_admin')
}

export function hasPermission(user: User | null | undefined, permission: string): boolean {
  if (!user) return false
  
  // Check permissions in token claims
  const permissions = (user['https://midwestrailbirds.com/permissions'] as string[]) || []
  
  return permissions.includes(permission)
}

export function getUserRole(user: User | null | undefined): string {
  if (!user) return 'guest'
  
  const permissions = (user['https://midwestrailbirds.com/permissions'] as string[]) || []
  
  if (permissions.includes('admin')) return 'admin'
  if (permissions.includes('pool_admin')) return 'pool_admin'
  if (permissions.length > 0) return 'user'
  
  return 'pending'
}
